import { BREAKPOINTS } from 'constants/breakpoints';
import useMediaQuery from 'hooks/useMediaQuery';

/**
 * Legacy mobile flag: true when viewport is below `sm` (768).
 * Shell sidebar/top-bar switching uses `useBreakpoint` (md) instead.
 */
export default function useIsMobile() {
  const isMobile = !useMediaQuery(`(min-width: ${BREAKPOINTS.sm}px)`);

  return {
    isMobile,
    /** @deprecated Prefer useBreakpoint / useMediaQuery; kept for callers that read width */
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
  };
}
